<!--  -->
<template>
  <div class="main_w">
    <img src="~@/assets/images/ad/ad2/12.png" alt="" class="img1" />
    <a href="https://i-item.jd.com/100019713995.html"
      ><img src="~@/assets/images/ad/ad2/13.png" alt="" class="img2 card"
    /></a>
    <a href="https://i-item.jd.com/100037135144.html"
      ><img src="~@/assets/images/ad/ad2/14.png" alt="" class="img3 card"
    /></a>
    <a href="https://i-item.jd.com/100019714013.html"
      ><img src="~@/assets/images/ad/ad2/15.png" alt="" class="img4 card"
    /></a>
    <a href="https://i-item.jd.com/100034703604.html"
      ><img src="~@/assets/images/ad/ad2/16.png" alt="" class="img5 card"
    /></a>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.main_w {
  position: relative;
  width: 100%;
  .card {
    position: absolute;
    width: 7.1rem;
    left: 0;
    right: 0;
    margin: auto;
    box-shadow: 0 0 .32rem 0 #9DDEFF;
  }
  .img2 {
    top: 5.6rem;
  }
  .img3 {
    top: 8.58rem;
  }
  .img4 {
    top: 11.56rem;
  }
  .img5 {
    top: 14.54rem;
  }
}
.img1 {
  width: 100%;
}
</style>